import React from 'react';
import type { RouteObject } from 'react-router-dom';

const CustomPage = React.lazy(() => import('@/pages/page'));

export const customPages: RouteObject[] = [
  {
    path: 'page/:slug',
    element: <CustomPage />,
  },
  {
    path: 'pages/:slug',
    element: <CustomPage />,
  },
];
